import React from 'react'
import { Text } from 'react-form'
import {Form, Col, FormGroup, Button, ControlLabel, Row} from 'react-bootstrap'
import ProgressBar from '../Common/ProgressBar/ProgressBar'

export default ({submitForm, message, isLoading}) => {
  return (
    <Form horizontal onSubmit={submitForm}>
      <Row className="FormWrapper">
        <Col lg={4} lgOffset={4} md={6} mdOffset={3} sm={8} smOffset={2} xs={12} xsOffset={0} className="Box">
          <h1 className="FormTitle">فراموشی رمز عبور</h1>
          {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}
          <FormGroup>
            <Col componentClass={ControlLabel} xs={4} >
              ایمیل
            </Col>
            <Col xs={7}>
              <Text
                field="email"
                type="email"
                placeholder="ایمیل"
                className="form-control"
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col xsOffset={4} xs={7}>
              <Button type="submit" className={`btnBlock ${isLoading && 'disabled'}`} bsStyle="success">
                ثبت
              </Button>
              <ProgressBar isLoading={isLoading} type="button" />
            </Col>
          </FormGroup>

        </Col>
      </Row>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/ForgetPassword/ForgetForm.js